import React from 'react';
import {
    Button,
    CircularProgress,
    IconButton,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Toolbar,
    Tooltip,
    Typography,
    withStyles
} from "material-ui";
import {connect} from "react-redux";
import {Add, Delete, Edit, FilterList, List} from "material-ui-icons";
import {
    closeGetRegulationsFetch,
    getRegulations,
    initializeRegulations,
    setEditRegulation
} from "../../redux/actions/regulations";
import {RegulationDialog} from "./dialog";
import {getRegulationCategories} from "../../redux/actions/regulation_categories";
import {Companies} from "../../components/companies";
import {getRegulationResults, setEditRegulationResult} from "../../redux/actions/regulation_results";
import {RegulationResultDialog} from "./dialog/result";
import {RegulationDeleteDialog} from "./dialog/delete";
import {CategoryDrawer} from "./drawer/category";
import {FilterDrawer} from "./drawer/filter";
import {openRegulationFilterDrawer} from "../../redux/actions/drawer";


const statuses = ['未対応', '適正', '不適正'];

export class RegulationComponent extends React.Component {

    state = {
        categoryDrawerOpen: false,
        dialogOpen: false,
        dialogResultOpen: false,
        dialogDeleteOpen: false,
    };

    componentDidMount = () => {
        document.title = '法令チェック | 三島事務所';
        this.props.initialize();

        if (!this.props.currentUser.is_admin) {
            this.props.getRegulations(this.props.currentUser.company_id);
        }
    };

    /**
     * 法令選択
     * @param company
     */
    onCompanySelect = (company) => {
        this.props.getRegulations(company.id);
    };

    /**
     * 法令編集
     * @param regulation
     */
    onRegulationEdit = (regulation) => {
        this.props.setEditRegulation(regulation);
        this.dialogOpen();
    };

    onRegulationResultEdit = (result) => {
        if (this.props.currentUser.is_admin) {
            this.props.setEditRegulationResult(result);
            this.dialogResultOpen();
        }
    };

    onRegulationDeleteEdit = (regulation) => {
        this.props.setEditRegulation(regulation);
        this.dialogDeleteOpen();
    };

    /**
     * ダイアログを開く
     */
    dialogOpen = () => {
        this.setState({dialogOpen: true});
    };

    /**
     * ダイアログを閉じる
     */
    dialogClose = () => {
        this.setState({dialogOpen: false});
        this.props.getRegulations(this.props.activeCompanyId);
        setTimeout(() => {
            this.props.setEditRegulation({});
            this.props.setEditRegulationResult({});
        }, 200);
    };

    dialogResultOpen = () => {
        this.setState({dialogResultOpen: true});
    };

    dialogResultClose = () => {
        this.setState({dialogResultOpen: false});
        this.props.getRegulations(this.props.activeCompanyId);
        setTimeout(() => {
            this.props.setEditRegulation({});
            this.props.setEditRegulationResult({});
        }, 200);
    };

    dialogDeleteClose = () => {
        this.setState({dialogDeleteOpen: false});
        this.props.getRegulations(this.props.activeCompanyId);
        setTimeout(() => {
            this.props.setEditRegulation({});
            this.props.setEditRegulationResult({});
        }, 200);
    };

    dialogDeleteOpen = () => {
        this.setState({dialogDeleteOpen: true});
    };

    getStatus = (regulation) => {
        let result = this.props.regulation_results.find((result) => {
            return result.regulation_id === regulation.id;
        });

        if (result === undefined) {
            return {
                regulation_id: regulation.id,
                status: 1,
            };
        }
        return result;
    };

    onCategoryDrawerOpen = () => {
        this.setState({categoryDrawerOpen: true});
    };

    onCategoryDrawerClose = () => {
        this.setState({categoryDrawerOpen: false});
    };

    onFilterDrawerClose = () => {
        this.props.getRegulations(this.props.activeCompanyId);
    };

    render() {

        const {
            classes,
            currentUser,
            regulations,
            regulation_categories,
            isGetRegulationsFetch,
            filter,
        } = this.props;

        const {dialogOpen, dialogResultOpen, dialogDeleteOpen, categoryDrawerOpen} = this.state;

        return (
            <div className={classes.root}>

                {currentUser.is_admin ?
                    <Companies
                        onCompanySelect={this.onCompanySelect}/> : null}

                <Paper className={classes.mainContainer}>

                    {!isGetRegulationsFetch && regulations.length === 0 ? '　法令リストが登録されていません' :
                        <div>
                            {isGetRegulationsFetch ? <CircularProgress/> :
                                <div>
                                    <Toolbar className={classes.toolbar}>
                                        <div className={classes.title}>
                                            <Typography variant="title">法令一覧</Typography>
                                        </div>
                                        <div className={classes.spacer}/>

                                        {currentUser.is_admin ?
                                            <div className={classes.actions}>
                                                <Tooltip title="カテゴリー管理">
                                                    <IconButton onClick={this.onCategoryDrawerOpen}>
                                                        <List/>
                                                    </IconButton>
                                                </Tooltip>
                                            </div>
                                            : ''}


                                        <div className={classes.actions}>
                                            <Tooltip title="フィルター">
                                                <IconButton onClick={this.props.openRegulationFilterDrawer}>
                                                    <FilterList/>
                                                </IconButton>
                                            </Tooltip>
                                        </div>
                                    </Toolbar>
                                    <Table>
                                        <TableHead>
                                            <TableRow>
                                                <TableCell className={classes.regulationStatus}>管理番号</TableCell>
                                                <TableCell className={classes.regulationStatus}>ステータス</TableCell>
                                                <TableCell className={classes.regulationStatus}>カテゴリー</TableCell>
                                                <TableCell>チェック項目</TableCell>
                                                {currentUser.is_admin ?
                                                    <TableCell className={classes.actionCell}>アクション</TableCell> : null}
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {regulations.map(n => {

                                                if (!filter[(this.getStatus(n)).status - 1]) {
                                                    return null;
                                                }

                                                return <TableRow key={n.id} hover>
                                                    <TableCell
                                                        onClick={this.onRegulationResultEdit.bind(this, this.getStatus(n))}
                                                        className={classes.clickCell}>
                                                        {n.sorts === null ? '未設定' : n.sorts}
                                                    </TableCell>
                                                    <TableCell
                                                        onClick={this.onRegulationResultEdit.bind(this, this.getStatus(n))}
                                                        className={classes.clickCell}>
                                                        {statuses[(this.getStatus(n)).status - 1]}
                                                    </TableCell>
                                                    <TableCell
                                                        onClick={this.onRegulationResultEdit.bind(this, this.getStatus(n))}
                                                        className={classes.clickCell}>
                                                        {n.regulation_category.name}
                                                    </TableCell>
                                                    <TableCell
                                                        onClick={this.onRegulationResultEdit.bind(this, this.getStatus(n))}
                                                        className={classes.clickCell}>
                                                        {n.name}</TableCell>
                                                    {currentUser.is_admin ?
                                                        <TableCell>
                                                            <IconButton
                                                                onClick={this.onRegulationEdit.bind(this, n)}>
                                                                <Edit/></IconButton>

                                                            <IconButton
                                                                onClick={this.onRegulationDeleteEdit.bind(this, n)}>
                                                                <Delete/></IconButton>
                                                        </TableCell>
                                                        : null}
                                                </TableRow>
                                            })}
                                        </TableBody>
                                    </Table>
                                </div>
                            }
                        </div>
                    }

                    {currentUser.is_admin ?
                        <Button variant="fab"
                                color="primary"
                                onClick={this.dialogOpen}
                                className={classes.fabButton}>
                            <Add/>
                        </Button>
                        : null}
                </Paper>

                <RegulationDialog
                    handleClose={this.dialogClose}
                    open={dialogOpen}
                    categories={regulation_categories}/>

                <RegulationResultDialog
                    open={dialogResultOpen}
                    handleClose={this.dialogResultClose}/>

                <RegulationDeleteDialog
                    open={dialogDeleteOpen}
                    handleClose={this.dialogDeleteClose}/>

                <CategoryDrawer
                    open={categoryDrawerOpen}
                    handleClose={this.onCategoryDrawerClose}/>

                <FilterDrawer
                    handleClose={this.onFilterDrawerClose}/>

            </div>
        )
    }
}

const styles = theme => ({
    root: {
        display: 'flex',
        height: 'calc(100vh - 64px)',
        position: 'relative',
    },
    mainContainer: {
        paddingTop: 4,
        background: '#fbfbfb',
        zIndex: 1,
        width: '100%',
        height: '100%',
        position: 'relative',
        overflow: 'auto',
    },
    fabButton: {
        position: 'fixed',
        bottom: theme.spacing.unit * 2,
        right: theme.spacing.unit * 2,
    },
    clickCell: {
        cursor: 'pointer'
    },
    actionCell: {
        width: 170,
    },
    title: {
        flex: '0 0 auto',
    },
    spacer: {
        flex: '1 1 100%',
    },
    regulationStatus: {
        width: 60,
    },
});

RegulationComponent = withStyles(styles)(RegulationComponent);
RegulationComponent = connect(
    (state) => {
        return {
            currentUser: state.users.currentUser,
            isGetRegulationsFetch: state.regulations.isGetRegulationsFetch,
            regulations: state.regulations.regulations,
            regulation_categories: state.regulation_categories.regulation_categories,
            regulation_results: state.regulation_results.regulation_results,
            activeCompanyId: state.app.activeCompanyId,
            filter: state.filter.regulation.status,
        }
    },
    (dispatch) => {
        return {
            initialize: () => {
                dispatch(initializeRegulations());
            },
            getRegulations: (companyId) => {
                Promise.all([
                    dispatch(getRegulations()),
                    dispatch(getRegulationResults(companyId)),
                    dispatch(getRegulationCategories()),
                ]).then(() => {
                    setTimeout(() => {
                        dispatch(closeGetRegulationsFetch());
                    }, 300);
                });
            },
            setEditRegulation: (regulation) => {
                dispatch(setEditRegulation(regulation));
            },
            setEditRegulationResult: (regulation) => {
                dispatch(setEditRegulationResult(regulation));
            },
            openRegulationFilterDrawer: () => {
                dispatch(openRegulationFilterDrawer());
            },
        }
    }
)(RegulationComponent);


// WEBPACK FOOTER //
// ./src/containers/regulation/index.js